module.exports = __webpack_public_path__ + "img/slider_5.cc0cc19c.jpg";